(() => {
 const init = root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('[data-catalog-form]');
  const grid = root.querySelector('.lgi-model-grid');
  const cards = [...grid.querySelectorAll('[data-catalog-card]')];
  const sort = root.querySelector('[data-catalog-sort]');
  const toggle = root.querySelector('[data-catalog-toggle]');
  const limit = toggle ? Number(root.dataset.catalogLimit) || 6 : Infinity;
  const groups = [...new Set([...form.querySelectorAll('input[type="checkbox"]')].map(input => input.name))];
  let expanded = false;
  const update = () => {
   const data = new FormData(form);
   const selected = groups.map(name => [name, data.getAll(name)]);
   const active = selected.reduce((sum, [, values]) => sum + values.length, 0);
   cards.sort((a,b) => sort.value === 'featured' ? Number(a.dataset.featured)-Number(b.dataset.featured) :
    (Number(a.dataset.generation)-Number(b.dataset.generation)) * (sort.value === 'oldest' ? 1 : -1)).forEach(card => grid.append(card));
   const matches = cards.filter(card => selected.every(([name, values]) => !values.length || values.some(value => (card.dataset[name] || '').split('|').includes(value))));
   const showMatches = root.hasAttribute('data-catalog-filter-all') && active > 0;
   const visible = expanded || showMatches ? matches : matches.slice(0, limit);
   const shown = new Set(visible);
   cards.forEach(card => { card.hidden = !shown.has(card); });
   root.querySelector('[data-catalog-count]').textContent = (visible.length < matches.length ? 'Showing '+visible.length+' of ' : '') + matches.length + (matches.length === 1 ? ' model' : ' models');
   root.querySelector('[data-catalog-empty]').hidden = matches.length !== 0;
   root.querySelector('[data-catalog-active]').textContent = active ? '('+active+')' : '';
   if (toggle) {
    toggle.hidden = matches.length <= limit || showMatches;
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.querySelector('[data-catalog-toggle-label]').textContent = expanded ? 'Show fewer models' : 'View all '+matches.length+' models';
   }
  };
  const resetView = () => { expanded = false; update(); };
  form.addEventListener('change', resetView);
  sort.addEventListener('change', resetView);
  form.addEventListener('reset', () => setTimeout(resetView, 0));
  root.querySelector('[data-catalog-clear]').addEventListener('click', () => form.reset());
  toggle?.addEventListener('click', () => {
   expanded = !expanded;
   update();
   if (!expanded) {
    const bounds = toggle.getBoundingClientRect();
    if (bounds.top < 0 || bounds.bottom > innerHeight) toggle.scrollIntoView({block:'nearest'});
   }
  });
  const media = matchMedia('(max-width: 700px)');
  const details = root.querySelector('[data-catalog-filters]');
  const adapt = () => { details.open = !media.matches; };
  adapt();
  media.addEventListener('change', adapt);
  details.addEventListener('toggle', () => { if (!media.matches && !details.open) details.open = true; });
  update();
 };
 document.querySelectorAll('[data-catalog]').forEach(init);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-catalog]').forEach(init));
})();
